//Third party libraries

import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';
import { kFormatter } from '@/utils';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../../types/Analytics';
//Assets and miscellaneous
import { Widget } from '../constants';
//Custom components
import WidgetLayout from '../WidgetLayout';

export interface IProjectBySourcesResponse {
  source_name: string;
  total_amount: string;
  _count: number;
}

interface IFundsWidgetResponse extends IProjectBySourcesResponse {
  amount_left?: string | number;
}

export const sourceLimits: Record<string, number> = {
  'HOME Funds': 1438242,
  'HOME ARPA Funds': 1438242,
  'ARPA Funds': 4691000,
  'CDBG Funds': 10050000, // TODO: Have to change when data provided
  'CDBG-DR': 4500004,
};

const FundsLeftWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchProjectBySourcesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_SOURCES,
  });

  const fundLeftWidgetData = fetchProjectBySourcesWidgetData?.data?.data || [];

  const fundLeftFilteredWidgetData = fundLeftWidgetData.filter((sourceData: { source_name: string }) =>
    Object.hasOwn(sourceLimits, sourceData.source_name)
  );

  const finalData = Object.keys(sourceLimits).reduce((acc: { source_name: string; amount_left: number }[], source) => {
    const limit = sourceLimits[source];
    const dbSource = fundLeftFilteredWidgetData.find((data: { source_name: string; total_amount: number }) => data.source_name === source);

    if (!dbSource) {
      acc.push({ source_name: source, amount_left: limit });
    } else {
      acc.push({
        ...dbSource,
        amount_left: limit - dbSource.total_amount,
      });
    }

    return acc;
  }, []);

  return (
    <>
      {finalData.map((source: Omit<IFundsWidgetResponse, '_count' | 'total_amount'>) => (
        <WidgetLayout key={source.source_name} dashboard={dashboard} widget={Widget.PROJECTS_BY_SOURCES} actionsBtnLocation='top-2 right-0'>
          <NumericMetricWidget
            title={`${source.source_name} Left`}
            value={source.amount_left ? kFormatter(source.amount_left as string) : '0'}
            prefix='$'
          />
        </WidgetLayout>
      ))}
    </>
  );
};

export default FundsLeftWidget;
